export var name = 'tickets';
export var TICKETS_SOCKET_PATH_NAME = 'sport-events/v1/ws/ticket-updates';
export var TICKET_UPDATES_NAME = 'ticket-updates';
export var UpdateTypes;
(function (UpdateTypes) {
    UpdateTypes["TICKET"] = "TICKET";
    UpdateTypes["ODD"] = "ODD";
    UpdateTypes["MATCH"] = "MATCH";
})(UpdateTypes || (UpdateTypes = {}));
